import React from 'react';
import { classes, useVisibility } from '../../../../lib';
import { FontAwesomeIcon } from '../../../FontAwesomeIcon';
import { Button } from '../../../Button';
import Styles from './TrainingSearchBar.module.less';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { TrainingBreadcrumb } from '../TrainingBreadcrumb';
import { TrainingDataType } from '../../../../lib/landingPage';
import { TrainingSearch } from '../../../../bound/landingPage/training/TrainingSearch/TrainingSearch';
import { TrainingMenuMobile } from '../TrainingMenuMobile';
import { whatsappColdSales } from '../../../../constants/support';

export type TrainingSearchBarProps = {
    trainingMenu: TrainingDataType;
    currentSlug: string;
    showMobileMenu?: boolean;
    showMobileDropdown?: boolean;
    showScheduleButton?: boolean;
    trackSchedule?: VoidFunction;
    hideMobileSearchButton?: boolean;
};
// eslint-disable-next-line complexity
export const TrainingSearchBar = ({
    trainingMenu,
    currentSlug,
    showMobileMenu,
    showMobileDropdown,
    showScheduleButton,
    hideMobileSearchButton,
    trackSchedule,
}: TrainingSearchBarProps) => {
    const [searchVisible, showSearch, hideSearch] = useVisibility();
    return (
        <div
            className={classes(
                'horizontal py8 px16 g8 regular-alude wrap',
                Styles.pathBar
            )}>
            {showMobileMenu && (
                <TrainingMenuMobile trainingMenu={trainingMenu} />
            )}
            <div
                className={classes(
                    'vertical td-left-middle',
                    showMobileDropdown ? 'm-center-middle' : 'm-left-middle',
                    Styles.breadcrumbContainer
                )}>
                <TrainingBreadcrumb
                    trainingMenu={trainingMenu}
                    currentSlug={currentSlug}
                    showMobileDropdown={showMobileDropdown}
                />
            </div>
            {showScheduleButton && (
                <Button
                    className="m-hidden"
                    type="primary"
                    onClick={trackSchedule}
                    href={whatsappColdSales}
                    target="_blank">
                    Falar com um especialista
                </Button>
            )}
            <Button
                className="m-hidden"
                type="default"
                onClick={showSearch}
                icon={<FontAwesomeIcon icon={faSearch} />}>
                Buscar
            </Button>

            {!hideMobileSearchButton && (
                <Button
                    className="td-hidden"
                    type="default"
                    onClick={showSearch}
                    icon={<FontAwesomeIcon icon={faSearch} />}
                />
            )}

            <TrainingSearch
                trainingMenu={trainingMenu}
                visible={searchVisible}
                hide={hideSearch}
            />
        </div>
    );
};
